import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  protoOf180f3jzyo7rfj as protoOf,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  Exceptiondt2hlxn7j7vw as Exception,
  Exception_init_$Init$33ewqhqmjrfx6 as Exception_init_$Init$,
  captureStack1fzi4aczwc4hg as captureStack,
  VOID3gxj6tk5isa35 as VOID,
  LinkedHashSet_init_$Create$3o6z3oewjhki9 as LinkedHashSet_init_$Create$,
  split2bvyvnrlcifjv as split,
  ArrayList_init_$Create$149jv2ovkkvnt as ArrayList_init_$Create$,
  listOfvhqybd2zx248 as listOf,
  _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx,
  startsWith1bgirhbedtv2y as startsWith,
  endsWith278181ii8uuo as endsWith,
  get_lastIndexld83bqhfgcdd as get_lastIndex,
  substringiqarkczpya5m as substring,
  Unit_instance1fbcbse1fwigr as Unit_instance,
  dropLastlqc2oyv04br0 as dropLast,
  emptyList1g2z5xcrvp2zy as emptyList,
  endsWith3cq61xxngobwh as endsWith_0,
  addAll1k27qatfgp3k5 as addAll,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
  StringBuilder_init_$Create$2qsge4ydj6bin as StringBuilder_init_$Create$,
  first58ocm7j58k3q as first,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  Collection1k04j3hzsbod0 as Collection,
  isInterface3d6p8outrmvmk as isInterface,
  firstOrNull1982767dljvdy as firstOrNull,
} from './kotlin-kotlin-stdlib.mjs';
import {
  EmptySerializersModule991ju6pz9b79 as EmptySerializersModule,
  AbstractEncoder2gxtu3xmy3f8j as AbstractEncoder,
  LIST_getInstancey7k5h8d5cvxt as LIST_getInstance,
  get_elementDescriptors13xxljc24xo44 as get_elementDescriptors,
} from './kotlinx-serialization-kotlinx-serialization-core.mjs';
import { filter216m038il6an5 as filter } from './ktor-ktor-utils.mjs';
import { ParametersBuilder1ry9ntvvg567r as ParametersBuilder } from './ktor-ktor-http.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
initMetadataForClass(Resource, 'Resource');
initMetadataForClass(ResourceSerializationException, 'ResourceSerializationException', VOID, Exception);
initMetadataForClass(Configuration, 'Configuration', Configuration);
initMetadataForClass(Resources, 'Resources');
initMetadataForClass(ParametersEncoder, 'ParametersEncoder', VOID, AbstractEncoder);
initMetadataForClass(ResourcesFormat, 'ResourcesFormat', ResourcesFormat);
//endregion
function Resource(path) {
  this.n3g_1 = path;
}
protoOf(Resource).equals = function (other) {
  if (!(other instanceof Resource))
    return false;
  var tmp0_other_with_cast = other instanceof Resource ? other : THROW_CCE();
  if (!(this.n3g_1 === tmp0_other_with_cast.n3g_1))
    return false;
  return true;
};
protoOf(Resource).hashCode = function () {
  return imul(getStringHashCode('path'), 127) ^ getStringHashCode(this.n3g_1);
};
protoOf(Resource).toString = function () {
  return '@io.ktor.resources.Resource(' + 'path=' + this.n3g_1 + ')';
};
function ResourceSerializationException(message) {
  Exception_init_$Init$(message, this);
  captureStack(this, ResourceSerializationException);
}
function Configuration() {
  this.o3g_1 = EmptySerializersModule();
}
function Resources(configuration) {
  this.p3g_1 = new ResourcesFormat(configuration.o3g_1);
}
function href(resourcesFormat, serializer, resource, urlBuilder) {
  var parameters = resourcesFormat.r3g(serializer, resource);
  var pathPattern = resourcesFormat.s3g(serializer);
  // Inline function 'kotlin.collections.mutableSetOf' call
  var usedForPathParameterNames = LinkedHashSet_init_$Create$();
  var pathParts = split(pathPattern, ['/']);
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList_init_$Create$();
  var _iterator__ex2g4s = pathParts.l();
  while (_iterator__ex2g4s.m()) {
    var element = _iterator__ex2g4s.n();
    var tmp$ret$1;
    $l$block_0: {
      if (!startsWith(element, _Char___init__impl__6a9atx(123)) || !endsWith(element, _Char___init__impl__6a9atx(125))) {
        tmp$ret$1 = listOf(element);
        break $l$block_0;
      }
      var part = substring(element, 1, get_lastIndex(element));
      var tmp;
      if (endsWith(part, _Char___init__impl__6a9atx(63))) {
        var tmp0_elvis_lhs = parameters.d2x(dropLast(part, 1));
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          tmp$ret$1 = emptyList();
          break $l$block_0;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var values = tmp_0;
        if (values.o() > 1) {
          throw new ResourceSerializationException('Expect zero or one parameter with name: ' + dropLast(part, 1) + ', but found ' + values.o());
        }
        // Inline function 'kotlin.collections.plusAssign' call
        var element_0 = dropLast(part, 1);
        usedForPathParameterNames.j(element_0);
        tmp = values;
      } else if (endsWith_0(part, '...')) {
        // Inline function 'kotlin.collections.plusAssign' call
        var element_1 = dropLast(part, 3);
        usedForPathParameterNames.j(element_1);
        var tmp1_elvis_lhs = parameters.d2x(dropLast(part, 3));
        tmp = tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
      } else {
        var values_0 = parameters.d2x(part);
        if (values_0 == null || !(values_0.o() === 1)) {
          var tmp3_elvis_lhs = values_0 == null ? null : values_0.o();
          throw new ResourceSerializationException('Expect exactly one parameter with name: ' + part + ', but found ' + (tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs));
        }
        // Inline function 'kotlin.collections.plusAssign' call
        usedForPathParameterNames.j(part);
        tmp = values_0;
      }
      tmp$ret$1 = tmp;
    }
    var list = tmp$ret$1;
    addAll(destination, list);
  }
  var updatedParts = destination;
  urlBuilder.n3e(updatedParts);
  var queryArgs = filter(parameters, VOID, href$lambda(usedForPathParameterNames));
  urlBuilder.c3d_1.j2x(queryArgs);
}
function href$lambda($usedForPathParameterNames) {
  return function (key, _unused_var__etf5q3) {
    return !$usedForPathParameterNames.q1(key);
  };
}
function _get_nextElementName__gjh25f($this) {
  var tmp = $this.v3g_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('nextElementName');
  }
}
function ParametersEncoder(serializersModule) {
  AbstractEncoder.call(this);
  this.t3g_1 = serializersModule;
  this.u3g_1 = ParametersBuilder();
}
protoOf(ParametersEncoder).ht = function () {
  return this.t3g_1;
};
protoOf(ParametersEncoder).w3g = function () {
  return this.u3g_1.z1m();
};
protoOf(ParametersEncoder).mt = function (value) {
  this.u3g_1.i2x(_get_nextElementName__gjh25f(this), toString(value));
};
protoOf(ParametersEncoder).lt = function (descriptor, index) {
  if (!equals(descriptor.zq(), LIST_getInstance())) {
    this.v3g_1 = descriptor.dr(index);
  }
  return true;
};
protoOf(ParametersEncoder).xt = function (enumDescriptor, index) {
  this.mt(enumDescriptor.dr(index));
};
protoOf(ParametersEncoder).nt = function () {
};
function ResourcesFormat(serializersModule) {
  serializersModule = serializersModule === VOID ? EmptySerializersModule() : serializersModule;
  this.q3g_1 = serializersModule;
}
protoOf(ResourcesFormat).ht = function () {
  return this.q3g_1;
};
protoOf(ResourcesFormat).s3g = function (serializer) {
  var pathBuilder = StringBuilder_init_$Create$();
  var current = serializer.fp();
  while (!(current == null)) {
    // Inline function 'kotlin.collections.filterIsInstance' call
    var tmp0 = current.cr();
    // Inline function 'kotlin.collections.filterIsInstanceTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.l();
    while (_iterator__ex2g4s.m()) {
      var element = _iterator__ex2g4s.n();
      if (element instanceof Resource) {
        destination.j(element);
      }
    }
    var path = first(destination).n3g_1;
    var tmp;
    var tmp_0;
    // Inline function 'kotlin.text.isNotEmpty' call
    if (charSequenceLength(pathBuilder) > 0) {
      tmp_0 = !startsWith(pathBuilder, _Char___init__impl__6a9atx(47));
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = !endsWith(path, _Char___init__impl__6a9atx(47));
    } else {
      tmp = false;
    }
    var addSlash = tmp;
    if (addSlash) {
      pathBuilder.ac(0, _Char___init__impl__6a9atx(47));
    }
    pathBuilder.bc(0, path);
    // Inline function 'kotlin.collections.filter' call
    var tmp0_0 = get_elementDescriptors(current);
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList_init_$Create$();
    var _iterator__ex2g4s_0 = tmp0_0.l();
    while (_iterator__ex2g4s_0.m()) {
      var element_0 = _iterator__ex2g4s_0.n();
      var tmp0_1 = element_0.cr();
      var tmp$ret$3;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var tmp_1;
        if (isInterface(tmp0_1, Collection)) {
          tmp_1 = tmp0_1.q();
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp$ret$3 = false;
          break $l$block_0;
        }
        var _iterator__ex2g4s_1 = tmp0_1.l();
        while (_iterator__ex2g4s_1.m()) {
          var element_1 = _iterator__ex2g4s_1.n();
          if (element_1 instanceof Resource) {
            tmp$ret$3 = true;
            break $l$block_0;
          }
        }
        tmp$ret$3 = false;
      }
      if (tmp$ret$3) {
        destination_0.j(element_0);
      }
    }
    var membersWithAnnotations = destination_0;
    if (membersWithAnnotations.o() > 1) {
      throw new ResourceSerializationException('There are multiple parents for resource ' + current.gq());
    }
    current = firstOrNull(membersWithAnnotations);
  }
  if (startsWith(pathBuilder, _Char___init__impl__6a9atx(47))) {
    pathBuilder.ec(0);
  }
  return pathBuilder.toString();
};
protoOf(ResourcesFormat).r3g = function (serializer, value) {
  var encoder = new ParametersEncoder(this.q3g_1);
  encoder.ku(serializer, value);
  return encoder.w3g();
};
//region block: exports
export {
  Configuration as Configuration2nkvs43ewppzi,
  Resources as Resourcesxj47ux575wgw,
  Resource as Resource72wyew2hkpsj,
  href as href1z2lyxpurwvcr,
};
//endregion

//# sourceMappingURL=ktor-ktor-resources.mjs.map
